// extracted by mini-css-extract-plugin
export var content = "_e6-3";
export var list = "_e6-4";
export var settingsContent = "_e6-7";
export var settingsPanel = "_e6-8";
export var state = "_e6-6";
export var triggerBadge = "_e6-2";
export var triggerButton = "_e6-1";
export var triggerShell = "_e6-0";
export var unreadDot = "_e6-5";